import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param sApi 查询接口
     * @param fetchCondition  当时搜索字段值Map

     * @param callback
     * @returns {Function}
     */
    fetch(sApi, data={}) {
        return request({
            url:  sApi,
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
